const doc = [({"da":({"js":({"routes":({"front":({"welcome":({"create_new_user":"Opret ny bruger"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;